import React, { useEffect, useRef, useState } from "react";
import { timerAlarmStart, timerLong } from "../../../env";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseCircleOutlineOutlinedIcon from "@mui/icons-material/PauseCircleOutlineOutlined";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
const NewTimer = () => {
  const [showTimer, setShowTimer] = useState<boolean>(false);
  const [value, setValue] = useState<number>(timerLong);
  const [helperValue, setHelperValue] = useState<number>(timerLong);
  const [selectedOption, setSelectedOption] = useState<string>("Music1");
  const player = useRef(null);
  const playStatus = useRef(0);
  const warningAlarm = useRef(null);
  const endAlarm = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (value === timerAlarmStart && warningAlarm.current)
        (warningAlarm.current as any).play();
      if (value === 0 && player.current && endAlarm.current) {
        (player.current as any).pause();
        (endAlarm.current as any).play();
        playStatus.current = 0;
      }
      if (playStatus.current === 0)
        setValue((prev) => (timerLong >= prev ? timerLong : prev));
      else if (playStatus.current === 1)
        setValue((v) => (v <= 0 ? value : v - 1));
      setHelperValue((v) => v - 1);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [helperValue]);
  const addMinutes = () => {
    setValue((prev) => prev + 60);
  };
  const subtractMinutes = () => {
    setValue((prev) => Math.max(prev - 60, 0)); // از صفر کمتر نمی‌شود
  };
  
  return (
    <div className=" relative cursor-pointer ml-1 ">
      <div
        className={`grid  grid-flow-col mt-1 py-1 text-center  justify-center items-center   border-neutral-200 border w-16  rounded-sm text-sm tooltip  tooltip-right ${
          showTimer ? "bg-[#f1e5ff]" : "bg-white"
        }`}
        data-tip="Timer, music"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.preventDefault();
          setShowTimer(!showTimer);
        }}
      >
        <span className="countdown  fontYekan font-semibold">
          {(value % 60).toString().padStart(2, "0")}:
        </span>

        <span className="countdown fontYekan font-semibold">
          {Math.floor(value / 60)
            .toString()
            .padStart(2, "0")}
        </span>
      </div>
      {/* <button
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.preventDefault();
                    setShowTimer(!showTimer);
                  }}
                  className={`btn  w-3 text-xs font-thin  btn-sm rounded-md  ml-3`}
                >
                  {!showTimer ? (
                    <AlarmOnIcon />
                  ) : (
                    <div className="w-5 h-5">
                      <AlarmOffIcon />
                    </div>
                  )}
                </button> */}

<div
  className={`absolute mt-0 left-2 transition-all ease-in-out duration-700 z-[1001] ${
    showTimer ? "opacity-100" : "opacity-0 pointer-events-none"
  } ${!showTimer ? "hidden" : "block"}`}
>

        <div className="w-60 h-88  bg-white shadow-2xl  relative rounded-md flex flex-col justify-start  items-center gap-y-2 ">
          <div className="grid  grid-flow-col gap-2   mt-1 py-1 text-center auto-cols-max justify-center items-center bg-slate-100 w-[90%]  rounded-md">
            <div className="flex flex-col h-20 p-2 bg-neutral rounded-box text-neutral-content">
              <span className="countdown font-mono text-5xl">
                {(value % 60).toString().padStart(2, "0")}
              </span>
              ثانیه
            </div>
            <div className="flex flex-col h-20 p-2 bg-neutral rounded-box text-neutral-content">
              <span className="countdown font-mono text-5xl">
                {Math.floor(value / 60)
                  .toString()
                  .padStart(2, "0")}
              </span>
              دقیقه
            </div>
          </div>
          <div className="w-[90%] flex justify-between ltr items-center">
            <button className="btn btn-xs btn-outline ltr" onClick={addMinutes}>
              + 1 min
            </button>
            <button className="btn btn-xs btn-outline ltr" onClick={subtractMinutes}>
              - 1 min
            </button>
            <div className="flex space-x-3">
              {playStatus.current !== 0 && (
                <div
                  onClick={() => {
                    playStatus.current = 0;
                    setValue(timerLong);
                  }}
                >
                  <div className="rounded-full border h-7 w-7 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                    >
                      <path
                        fill="#000"
                        fill-opacity=".9"
                        fill-rule="evenodd"
                        stroke="none"
                        d="M20 12h-8v8h8v-8zm-9-1v10h10V11H11z"
                      ></path>
                    </svg>
                  </div>
                </div>
              )}
              {playStatus.current !== 1 && (
                <div onClick={() => (playStatus.current = 1)}>
                  <div className="rounded-full bg-purple-600 h-7 w-7 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="12"
                      viewBox="0 0 14 12"
                    >
                      <path
                        fill="#fff"
                        fill-opacity="1"
                        fill-rule="evenodd"
                        stroke="none"
                        d="m4 .098.765.478 8 5 .678.424-.678.424-8 5-.765.478V.098zm1 1.804v8.196L11.557 6 5 1.902z"
                      ></path>
                    </svg>
                  </div>
                  {/* <PlayCircleIcon /> */}
                </div>
              )}
              {playStatus.current === 1 && (
                <div onClick={() => (playStatus.current = 2)}>
                  <div className="rounded-full border h-7 w-7 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="10"
                      viewBox="0 0 12 10"
                    >
                      <path
                        fill="#000"
                        fill-opacity="1"
                        fill-rule="evenodd"
                        stroke="none"
                        d="M11 1H8v8h3V1zM4 1H1v8h3V1zM0 0v10h5V0H0zm7 0v10h5V0H7z"
                      ></path>
                    </svg>
                  </div>
                  {/* <PauseCircleOutlineOutlinedIcon /> */}
                </div>
              )}
            </div>
          </div>
          <div className="divider my-0 h-0" />
          <div className="h-24 w-full ltr">
            <img
              src="/images/timerImage.jpg"
              className="object-fill	 h-24 w-[95%]"
              alt="timerImage"
            />
          </div>
          <div className="w-[90%] ltr">
            <select
              value={selectedOption}
              onChange={(e) => {
                setSelectedOption(e.target.value);
                (player.current as any).pause();
                (player.current as any).load();
              }}
              className="h-8 w-full rounded-md border-r-2 border-transparent px-2 text-sm bg-slate-50  outline-neutral-700"
            >
              <option value="Music1" selected>
                Music 1
              </option>
              <option value="Music2">Music 2</option>
              <option value="Music3">Music 3</option>
              <option value="Music4">Music 4</option>
            </select>
          </div>
          <div className="w-full ">
            <audio
              ref={player}
              id=""
              className="w-full "
              controls
              loop
              controlsList="nodownload nofullscreen noplaybackrate"
            >
              <source src={`/music/${selectedOption}.mp3`} type="audio/mp3" />
            </audio>
            <audio
              ref={warningAlarm}
              id=""
              className="hidden "
              controls
              controlsList="nodownload nofullscreen noplaybackrate"
            >
              <source src={`/alarm/warningAlarm.mp3`} type="audio/mp3" />
            </audio>
            <audio
              ref={endAlarm}
              id=""
              className="hidden "
              controls
              controlsList="nodownload nofullscreen noplaybackrate"
            >
              <source src={`/alarm/endAlarm.mp3`} type="audio/mp3" />
            </audio>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTimer;
